/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  makeStyles,
  useMediaQuery,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import CardComponent from "app/common/CardComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "300px",
    flexWrap: "wrap",
    display: "flex",
    maxHeight: "inherit",
    overflowY: "auto",
  },
  rootSmall: {
    width: "200px",
    flexWrap: "wrap",
    display: "flex",
    maxHeight: "inherit",
    overflowY: "auto",
  },
  containerField: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    width: "fit-content",
    marginRight: "5px",
    marginBottom: "5px",
    marginTop: "2px",
    borderRadius: 4,
    padding: "5px",
  },
}));

const StyledTypography = withStyles(() => ({
  root: { paddingLeft: "5px", paddingRight: "5px" },
}))(Typography);

const ExportPreview = ({ fieldsData }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const classes = useStyles();
  return (
    <CardComponent
      styleCard
      body={
        <Box className={isSmallScreen ? classes.rootSmall : classes.root}>
          {fieldsData.map((fieldOption) => (
            <Tooltip
              title={fieldOption.tooltip}
              placement="right"
              key={fieldOption.id}
            >
              <div className={classes.containerField}>
                <StyledTypography variant="body1">
                  {fieldOption.field}
                </StyledTypography>
              </div>
            </Tooltip>
          ))}
        </Box>
      }
    />
  );
};

export default ExportPreview;
